enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  NONE = 4
}

class Logger {
  private level: LogLevel;

  constructor() {
    // In production, only show warnings and errors by default
    this.level = import.meta.env.PROD ? LogLevel.WARN : LogLevel.DEBUG;
  }

  setLevel(level: LogLevel) {
    this.level = level;
  }

  debug(tag: string, ...args: any[]) {
    if (this.level <= LogLevel.DEBUG) {
      console.debug(`[${tag}]`, ...args);
    }
  }

  log(tag: string, ...args: any[]) {
    if (this.level <= LogLevel.INFO) {
      console.log(`[${tag}]`, ...args);
    }
  }

  info(tag: string, ...args: any[]) {
    if (this.level <= LogLevel.INFO) {
      console.info(`[${tag}]`, ...args);
    }
  }

  warn(tag: string, ...args: any[]) {
    if (this.level <= LogLevel.WARN) {
      console.warn(`[${tag}]`, ...args);
    }
  }

  error(tag: string, ...args: any[]) {
    if (this.level <= LogLevel.ERROR) {
      console.error(`[${tag}]`, ...args);
    }
  }
}

export const logger = new Logger();
export { LogLevel };

